import type { Release } from '../releases';

export default {
  id: '2026-11-04-list-settings-link',
  at: '2026-11-04T10:23:00Z',
  title: 'Кнопка «Настроить список» на страницах-списках разделов',
  modules: ['contracts', 'lists', 'portfolio', 'procurement', 'changes', 'supervision', 'suppliers'],
  items: [
    'На портфеле проектов, в договорах, заявках на закупку и заявках на оплату, изменениях, замечаниях и вопросах к проекту и в реестре контрагентов появилась кнопка «Настроить список». Она открывает тот же список в «Отчётах», где можно выбрать колонки, отбор, группировку и итоги, сохранить свой вид и выгрузить его в Excel или PDF.',
    'Кнопка видна, только если этот список открыт вам по правам; суммы в нём — по вашему уровню доступа к деньгам.',
  ],
  why: 'Настраиваемые списки были спрятаны в «Отчётах», и о них мало кто знал; теперь в них можно перейти прямо со страницы раздела.',
  link: '/contracts',
} satisfies Release;
